/**
 * PropGen auth shim. PropGen originally expected `user.is_admin` and
 * `user.can_see_internal` flags on the current user. Peak's user shape has
 * `is_superadmin` instead. Since every PropGen page is gated at the router
 * level to superadmins only, we can safely map both flags to `is_superadmin`.
 *
 * This lets the ported PropGen pages/components use the same `useAuth()` API
 * without needing to be rewritten.
 */
import { useAuth as usePeakAuth } from "@/context/AuthContext";

export function useAuth() {
  const ctx = usePeakAuth();
  const raw = ctx?.user || null;
  if (!raw) return ctx;
  const augmented = {
    ...raw,
    is_admin: !!raw.is_superadmin,
    can_see_internal: !!raw.is_superadmin,
  };
  return { ...ctx, user: augmented };
}
